export const TEST_ID = 'quickActionChip';
